/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VideoHistoryAnswer
 */
export interface VideoHistoryAnswer {
    /**
     * 
     * @type {string}
     * @memberof VideoHistoryAnswer
     */
    videoTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof VideoHistoryAnswer
     */
    dateCompleted?: string;
}

export function VideoHistoryAnswerFromJSON(json: any): VideoHistoryAnswer {
    return VideoHistoryAnswerFromJSONTyped(json, false);
}

export function VideoHistoryAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): VideoHistoryAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'videoTitle': !exists(json, 'video-title') ? undefined : json['video-title'],
        'dateCompleted': !exists(json, 'date-completed') ? undefined : json['date-completed'],
    };
}

export function VideoHistoryAnswerToJSON(value?: VideoHistoryAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'video-title': value.videoTitle,
        'date-completed': value.dateCompleted,
    };
}


